import { render, staticRenderFns } from "./OrderPayFailIframe.vue?vue&type=template&id=36729c58&"
import script from "./OrderPayFailIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderPayFailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports